// extracted by mini-css-extract-plugin
module.exports = {"container":"ApprovePaymentModalButton_container__wE-UX","button":"ApprovePaymentModalButton_button__35hj_","button-ltr":"ApprovePaymentModalButton_button-ltr__wwYFY"};